// eslint-disable-next-line import/no-unresolved
module.exports = require('./build/OutsideClickHandler');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/react-outside-click-handler/index.js
// module id = 466
// module chunks = 168707334958949